import { Box, Loader, ScrollContainer, Stack, Typography } from "@tm/components"
import { batch, useDispatch, useSelector } from "react-redux"
import { RimDetailsArticle } from "@bundles/wheels/data/model"
import { useLocalization } from "@tm/localization"
import { useCallback } from "react"
import { MainState } from "../../main"
import { RimDetailsArticleV2 } from "./rimDetailsArticleV2"
import { Actions } from "../business"
import { StatusPanel } from "./statusPanel"

export function RimArticleListV2() {
    const dispatch = useDispatch()
    const { translateText } = useLocalization()
    const { rimItem, loading, data, error, selectedRimDetailsArticle } = useSelector((s: MainState) => ({
        rimItem: s.wheelsDetails.rimItem,
        loading: s.wheelsDetails.rimDetailsArticlesResponse.loading,
        data: s.wheelsDetails.rimDetailsArticlesResponse.data,
        error: s.wheelsDetails.rimDetailsArticlesResponse.error,
        selectedRimDetailsArticle: s.wheelsDetails.selectedRimDetailsArticle,
    }))

    const handleSelectItem = useCallback((rim: RimDetailsArticle) => {
        batch(() => {
            dispatch(Actions.selectRimDetailsArticle(rim))
            dispatch(Actions.loadRimDetailsAndRestrictions(rim))
            dispatch(Actions.selectTireSize(undefined))
        })
    }, [])

    const handleRimQuantityChange = useCallback(
        (article: RimDetailsArticle, value: number, linkedArticleChanged?: boolean) => {
            if (linkedArticleChanged) {
                dispatch(Actions.changeAccessoryKitArticleQuantity(article, value))
            } else {
                dispatch(Actions.changeRimDetailsArticleQuantity(article, value))
            }
        },
        [rimItem?.idRimDesign]
    )

    if (loading) {
        return (
            <StatusPanel>
                <Loader />
            </StatusPanel>
        )
    }

    if (!data || !Object.keys(data).length || error) {
        return (
            <StatusPanel>
                <Typography>{translateText(323)}</Typography>
            </StatusPanel>
        )
    }

    const renderRimArticle = ([group, articles]: [string, RimDetailsArticle[]], idx: number) => {
        const uniqueRimSizes = articles.map((x) => x.rimSize).distinct()
        return (
            <Box padding=".5em .25em" key={idx}>
                <Stack direction="row" gap={0.5} mb={0.5}>
                    {uniqueRimSizes.map((x) => (
                        <Typography variant="h3" key={group + x}>
                            {x}
                        </Typography>
                    ))}
                </Stack>
                {articles.map((x, artIDx) => (
                    <RimDetailsArticleV2
                        key={artIDx + x.applicationId || x.eanCode}
                        item={x}
                        onSelectItem={handleSelectItem}
                        onQuantityChange={handleRimQuantityChange}
                        isSelected={
                            selectedRimDetailsArticle?.artNr === x.artNr &&
                            selectedRimDetailsArticle?.appType === x.appType &&
                            selectedRimDetailsArticle?.idRim === x.idRim &&
                            selectedRimDetailsArticle?.applicationId === x.applicationId
                        }
                    />
                ))}
            </Box>
        )
    }
    return <ScrollContainer sx={{ maxHeight: "22.5em" }}>{Object.entries(data).map(renderRimArticle)}</ScrollContainer>
}
